import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AppHeaderDefault, BaseButtonFill } from '..';
import { HalfPageLayout } from '../HalfPageLayout/HalfPageLayout';

import './UserRegistrationConfirmation.scss';

const UserRegistrationConfirmationContent = ({ common, navigate }) => (
  <div className="user-registration-confirmation__content">
    <h1 className="heading heading--secondary">{common('register.confirmation')}</h1>
    <BaseButtonFill
      iconRight
      icon="arrow-right"
      onClick={() => navigate('/login')}
      data-testid="register-confirmation-button"
    >
      {common('register.login')}
    </BaseButtonFill>
  </div>
);

const UserRegistrationConfirmation = ({ isAdvisor }) => {
  const { t: common } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <AppHeaderDefault isAdvisor={isAdvisor}>
      <div className="user-registration-confirmation">
        <HalfPageLayout rightContent={<UserRegistrationConfirmationContent common={common} navigate={navigate} />} />
      </div>
    </AppHeaderDefault>
  );
};

export default UserRegistrationConfirmation;
